import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Dalek', sans-serif`,
  },
});

export default theme;
